import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SubscriptionPreview } from '../model/subscription-preview';
import { SubscriptionApiService } from './subscription-api.service';

@Injectable({ providedIn: 'root' })
export class SubscriptionService {
  constructor(
    private readonly subscriptionApiService: SubscriptionApiService
  ) {}

  public previewSubscription(
    productName: string,
    couponCode: string | null,
    referralCode: string | null
  ): Observable<SubscriptionPreview> {
    return this.subscriptionApiService.previewSubscription(
      productName,
      couponCode,
      referralCode
    );
  }
}
